/**
 * De triggers van de notificatielijst "Product updates" (BMX-52).
 *
 * Losse module zonder firebase-import, zodat de herstelregel te testen is zonder de hele
 * CMS-pagina (en daarmee Firebase) op te tuigen -- zelfde opzet als functions/priceImport.js.
 */

/**
 * De triggers waar de weekmail op filtert. Deze namen moeten exact overeenkomen met het `type`
 * dat de cloud function naar productEvents schrijft
 * (cloud-functions/src/shared/productEvents.js): de digest doet `allowedTriggers.has(event.type)`,
 * dus een naam die er net naast zit betekent stilzwijgend geen mail.
 *
 * HIDDEN en VISIBLE staan hier bewust niet bij. Dat is interne historie voor het
 * productupdates-overzicht, geen nieuws voor een klant.
 */
export const SYSTEM_AUDIENCE_TRIGGERS = [
  "OUT_OF_STOCK",
  "IN_STOCK",
  "LOW_IN_STOCK",
  "PREORDER_ENABLED",
  "NEW_PRODUCT",
  "DISCONTINUED",
];

/**
 * Oude schrijfwijzen die nog in bestaande documenten kunnen staan.
 *
 * De lijst is ooit geseed met "NEW" terwijl het event "NEW_PRODUCT" heet. Daardoor is er sinds
 * de allereerste versie geen enkel nieuw product in de weekmail terechtgekomen: de digest gooide
 * elk NEW_PRODUCT-event weg omdat het niet in de triggers stond.
 */
const LEGACY_TRIGGER_ALIASES = { NEW: "NEW_PRODUCT" };

/**
 * De triggers die deze story toevoegt en dus in een bestaand document kunnen ontbreken.
 *
 * Bewust niet de hele lijst forceren: alleen wat aantoonbaar kapot of nieuw is wordt bijgewerkt,
 * zodat een bewuste keuze op de andere triggers blijft staan als die ooit instelbaar worden.
 */
const REQUIRED_TRIGGERS = ["NEW_PRODUCT", "DISCONTINUED"];

/**
 * De triggers zoals ze zouden moeten staan, of null als er niets te herstellen valt.
 *
 * Geeft null terug bij "al goed", zodat de aanroeper niet elke keer een schrijfactie doet op een
 * document dat niet verandert.
 */
export const repairSystemAudienceTriggers = (triggers) => {
  const current = Array.isArray(triggers) ? triggers : [];
  const normalized = current.map((trigger) => LEGACY_TRIGGER_ALIASES[trigger] || trigger);
  const missing = REQUIRED_TRIGGERS.filter((trigger) => !normalized.includes(trigger));
  const repaired = Array.from(new Set([...normalized, ...missing]));

  const unchanged = repaired.length === current.length && repaired.every((trigger, i) => trigger === current[i]);
  return unchanged ? null : repaired;
};
